import { memo } from 'react';
import { Grid, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

/**
 * Cart header with title and close button
 * Memoized to prevent unnecessary re-renders
 */
const CartHeader = memo(({ itemCount, onClose }) => {

  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{ padding: '15px 20px', marginBottom: '10px' }}
    >
      <Grid item>
        <Typography
          variant="h6"
          sx={{
            fontFamily: 'Jost, sans-serif',
            color: '#172B4D',
            fontWeight: '700',
            fontSize: '20px',
            textTransform: 'none',
          }}
        >
          Shopping Cart ({itemCount})
        </Typography>
      </Grid>
      <Grid item>
        <CloseIcon
          sx={{
            color: '#1A1A1A',
            cursor: 'pointer',
            width: '24px',
            height: '24px',
            '&:hover': {
              opacity: 0.7,
            },
          }}
          onClick={onClose}
        />
      </Grid>
    </Grid>
  );
});

CartHeader.displayName = 'CartHeader';

export default CartHeader;
